import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  MenuItem,
  Link,
  CircularProgress,
} from "@mui/material";
import { toast } from 'react-toastify';
import Header from "../components/Navbar";
import Footer from "../components/Footer";
import loginBI from "../assets/Images/login-bc.png";
import { postData } from "../services/Request";
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    address: "",
    category: "",
    companyName: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      name: form.name,
      email: form.email,
      password: form.password,
      type: form.category,
      company_name: form.companyName,
      address: form.address,
    };

    try {
      const res = await postData("api/auth/signup", payload);

      if (res.status === true) {
        toast.success(res.message || "Signup successful!");
        navigate("/Login");
        setLoading(false)
      }
      if (res.status === false){
        toast.error(res?.message || "Signup failed!");
        setLoading(false)
      }
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error("Something went wrong! Please try again.");
      setLoading(false)
    }
  };

  return (
    <>
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${loginBI})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          px: 2,
          backgroundColor: "#7d9368",
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={8}
            sx={{
              p: { xs: 3, sm: 5 },
              borderRadius: 4,
              backdropFilter: "blur(16px)",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              boxShadow: "0px 8px 30px rgba(0,0,0,0.3)",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                mb: 1,
                textAlign: "center",
                color: "#2f3e46",
              }}
            >
              Create Account
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#4f5d63",
                mb: 4,
                textAlign: "center",
              }}
            >
              Please fill the form to sign up.
            </Typography>

            <form onSubmit={handleSubmit}>
              <TextField
                label="Full Name"
                name="name"
                fullWidth
                margin="normal"
                value={form.name}
                onChange={handleChange}
                required
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                margin="normal"
                value={form.email}
                onChange={handleChange}
                required
              />
              <TextField
                label="Password"
                name="password"
                type="password"
                fullWidth
                margin="normal"
                value={form.password}
                onChange={handleChange}
                required
              />
              <TextField
                label="Address"
                name="address"
                fullWidth
                margin="normal"
                value={form.address}
                onChange={handleChange}
                required
              />
              <TextField
                select
                label="Select Category"
                name="category"
                fullWidth
                margin="normal"
                value={form.category}
                onChange={handleChange}
                required
              >
                <MenuItem value="agent">Agent</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="user">User</MenuItem>
              </TextField>
              <TextField
                label="Company Name"
                name="companyName"
                fullWidth
                margin="normal"
                value={form.companyName}
                onChange={handleChange}
                required
              />

              <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    sx={{
                      mt: 2,
                      background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                      borderRadius: "8px",
                      fontWeight: "bold",
                      "&:hover": {
                        background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                      },
                    }}
                  >
                    {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Sign Up"}
               </Button>
              <Typography
                variant="body2"
                sx={{ textAlign: "center", mt: 2, color: "gray" }}
              >
                Already have an account?{" "}
                <Link
                  href="/login"
                  sx={{
                    color: "#8bbd5d",
                    fontWeight: "bold",
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Login
                </Link>
              </Typography>
            </form>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default SignUpPage;
